function arrayOf(value) {
  return Array.isArray(value) ? value : [];
}

function eventMetadata(event) {
  return event?.metadata && typeof event.metadata === "object" ? event.metadata : {};
}

export function isPlanChargeEvent(event) {
  if (event?.event_type !== "charge") return false;
  const metadata = eventMetadata(event);
  return Boolean(
    event.treatment_plan_id
      || event.procedure_visit_id
      || metadata.treatment_plan_id
      || metadata.plan_id
      || metadata.plan_code
      || metadata.source === "plan_acceptance"
      || metadata.source === "plan_visit_charge"
      || metadata.source === "tx_plan",
  );
}

export function buildVisitBreakdown({ visit, enrichment } = {}) {
  const events = arrayOf(visit?.events);
  const charges = events.filter((event) => event?.event_type === "charge");
  const ledgerEvents = events.filter((event) => event?.event_type !== "charge");
  const planChargeEvents = charges.filter(isPlanChargeEvent);
  const standaloneProceduresDone = charges
    .filter((event) => !isPlanChargeEvent(event))
    .map((event) => ({
      id: event.id,
      procedure_name: event.procedure_name || eventMetadata(event).custom_name || "Procedure",
      amount_centavos: Number(event.amount_centavos || 0),
      tooth_number: event.tooth_number || eventMetadata(event).tooth_number || null,
      surface: event.surface || eventMetadata(event).surface || null,
      event,
    }));

  return {
    planItemsDone: arrayOf(enrichment?.txPlanItemsDone),
    standaloneProceduresDone,
    futureNeedsPlaced: arrayOf(enrichment?.futureNeedsPlaced),
    paymentAllocations: arrayOf(enrichment?.paymentAllocations),
    ledgerEvents,
    planChargeEvents,
    hasActivity: Boolean(
      arrayOf(enrichment?.txPlanItemsDone).length
        || standaloneProceduresDone.length
        || arrayOf(enrichment?.futureNeedsPlaced).length
        || arrayOf(enrichment?.paymentAllocations).length
        || ledgerEvents.length
        || planChargeEvents.length,
    ),
  };
}
